import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Header } from "./components/Header";
import { LoginCards } from "./components/LoginCards";
import { DownloadSection } from "./components/DownloadSection";
import { AnnouncementSection } from "./components/AnnouncementSection";
import { CompanyCulture } from "./components/CompanyCulture";
import { Footer } from "./components/Footer";
import RegisterPage from "./pages/Register";
import ExpertRegisterPage from "./pages/ExpertRegister";
import LoginPage from "./pages/Login";
import CompleteInfoPage from "./pages/CompleteInfo";
import MyBidsPage from "./pages/MyBids";
import PurchaserBidsPage from "./pages/PurchaserBids";
import TradeAnnouncementsPage from "./pages/TradeAnnouncements";
import AnnouncementDetailPage from "./pages/AnnouncementDetail";
import PaymentPage from "./pages/Payment";
import PaymentResultPage from "./pages/PaymentResult";
import PolicyListPage from "./pages/PolicyList";
import PolicyDetailPage from "./pages/PolicyDetail";
import IndustryNewsListPage from "./pages/IndustryNewsList";
import IndustryNewsDetailPage from "./pages/IndustryNewsDetail";
import CompanyCultureListPage from "./pages/CompanyCultureList";
import CompanyCultureDetailPage from "./pages/CompanyCultureDetail";
import AboutPage from "./pages/About";
import AboutXinyuanPage from "./pages/AboutXinyuan";
import DownloadCenterPage from "./pages/DownloadCenter";
import PartnersPage from "./pages/Partners";
import ExpertEvaluationPage from "./pages/ExpertEvaluation";
import AdminLogin from "./pages/admin/Login";
import AdminLayout from "./pages/admin/Layout";
import Dashboard from "./pages/admin/Dashboard";
import Users from "./pages/admin/Users";
import Bids from "./pages/admin/Bids";
import Announcements from "./pages/admin/Announcements";
import Invoices from "./pages/admin/Invoices";
import Annex from "./pages/admin/Annex";
import Members from "./pages/admin/Members";
// 新增的管理后台页面
import BidTender from "./pages/admin/BidTender";
import BidResult from "./pages/admin/BidResult";
import BidOther from "./pages/admin/BidOther";
import OrderCenter from "./pages/admin/OrderCenter";
import InfoCompany from "./pages/admin/InfoCompany";
import InfoIndustry from "./pages/admin/InfoIndustry";
import InfoPolicy from "./pages/admin/InfoPolicy";
import AccountSupplierAudit from "./pages/admin/AccountSupplierAudit";
import AccountSupplier from "./pages/admin/AccountSupplier";
import AccountExpertAudit from "./pages/admin/AccountExpertAudit";
import AccountExpert from "./pages/admin/AccountExpert";
import AccountPurchaser from "./pages/admin/AccountPurchaser";
import SystemMembers from "./pages/admin/SystemMembers";
import SystemRoles from "./pages/admin/SystemRoles";
import DownloadCenter from "./pages/admin/DownloadCenter";
import SupplierRegistrationList from "./pages/admin/SupplierRegistrationList";
import OtherAnnouncementRegistrationList from "./pages/admin/OtherAnnouncementRegistrationList";
import TodayOpenBid from "./pages/admin/TodayOpenBid";
import UserFeedback from "./pages/admin/UserFeedback";
import DownloadRecord from "./pages/admin/DownloadRecord";
import { useEffect, useRef, useState } from "react";
import { ConfigProvider, message } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { CountdownModal } from "./components/CountdownModal";
import { removeToken, removeUser } from "./utils/api";

// 首页组件
function HomePage() {
  const [showCountdown, setShowCountdown] = useState(false);
  const [userCreateTime, setUserCreateTime] = useState<string>('');
  
  // 处理点击事件，如果用户是预注册状态且未完善信息，则拦截点击并显示弹窗
  useEffect(() => {
    const handleGlobalClick = (e: MouseEvent) => {
      // 如果弹窗已经显示，不做处理
      if (showCountdown) return;
      
      // 如果当前在登录页或注册页，不触发弹窗
      if (window.location.pathname === '/login' || 
          window.location.pathname === '/register' || 
          window.location.pathname === '/expert-register' ||
          window.location.pathname === '/complete-info') return;

      // 如果点击的是弹窗内的元素或注销按钮，不做处理
      const target = e.target as HTMLElement;
      if (target.closest('.countdown-modal-content') || target.closest('.logout-btn')) return;
      
      const userStr = localStorage.getItem('user');
      if (userStr) {
        try {
          const user = JSON.parse(userStr);
          if (user.type === '预注册' && user.create_time) {
            // 阻止默认行为和冒泡
            e.stopPropagation();
            e.preventDefault();
            
            setUserCreateTime(user.create_time);
            setShowCountdown(true);
          }
        } catch (e) {
          // 忽略解析错误
        }
      }
    };

    // 使用捕获阶段监听，确保在其他事件处理之前拦截
    document.addEventListener('click', handleGlobalClick, true);
    
    return () => {
      document.removeEventListener('click', handleGlobalClick, true);
    };
  }, [showCountdown]);

  // 初始检查
  useEffect(() => {
    // 检查用户是否已登录且为预注册状态
    // 如果当前在登录页或注册页，不触发弹窗
    if (window.location.pathname === '/login' || 
        window.location.pathname === '/register' || 
        window.location.pathname === '/expert-register' ||
        window.location.pathname === '/complete-info') return;

    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        if (user.type === '预注册' && user.create_time) {
          setUserCreateTime(user.create_time);
          setShowCountdown(true);
        }
      } catch (e) {
        // 忽略解析错误
      }
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="container mx-auto px-4 py-4 md:py-8 hidden lg:block">
        <div className="flex flex-col gap-6">
          <LoginCards />
          <DownloadSection />
        </div>
      </div>
      <div className="lg:hidden container mx-auto px-4 mt-4 space-y-4">
        <LoginCards />
        <DownloadSection />
      </div>
      <div className="container mx-auto px-4 pt-0 pb-4 md:pb-8 space-y-4 md:space-y-8">
        <AnnouncementSection />
        <CompanyCulture />
      </div>
      <Footer />
      
      {/* 倒计时弹窗 */}
      {showCountdown && userCreateTime && (
        <CountdownModal
          createTime={userCreateTime}
          onComplete={() => setShowCountdown(false)}
          onCancel={() => setShowCountdown(false)}
        />
      )}
    </div>
  );
}

// 管理后台路由守卫
function AdminRoute({ children }: { children: React.ReactNode }) {
  const [isValid, setIsValid] = useState<boolean | null>(null);
  const adminToken = localStorage.getItem('admin_token');
  
  useEffect(() => {
    if (!adminToken) {
      setIsValid(false);
      return;
    }
    
    // 验证 token 是否有效
    fetch('/api/admin/verify-token', {
      headers: { 'Authorization': `Bearer ${adminToken}` }
    })
      .then(r => r.json())
      .then(data => {
        if (data.ok) {
          setIsValid(true);
        } else {
          // token 无效或过期，清除并跳转
          localStorage.removeItem('admin_token');
          localStorage.removeItem('admin_user');
          setIsValid(false);
        }
      })
      .catch(() => {
        // 网络错误时保持登录状态
        setIsValid(true);
      });
  }, [adminToken]);
  
  // 加载中
  if (isValid === null) {
    return (
      <div style={{ 
        height: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        backgroundColor: '#f0f2f5'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '16px', color: '#666' }}>验证登录状态...</div>
        </div>
      </div>
    );
  }
  
  if (!isValid) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return <>{children}</>;
}

// 管理后台登录页路由守卫（已登录则跳转）
function AdminLoginRoute() {
  const adminToken = localStorage.getItem('admin_token');
  
  if (adminToken) {
    const adminUser = localStorage.getItem('admin_user');
    const userInfo = adminUser ? JSON.parse(adminUser) : null;
    const roleName = userInfo?.role_name || null;
    
    // 根据角色跳转到不同页面
    if (roleName === '项目经理') {
      return <Navigate to="/admin/today-open-bid" replace />;
    } else if (roleName === '财务人员') {
      return <Navigate to="/admin/order-management" replace />;
    }
    return <Navigate to="/admin/dashboard" replace />;
  }
  
  return <AdminLogin />;
}

// 管理后台默认路由（根据角色跳转）
function AdminDefaultRoute() {
  const adminUser = localStorage.getItem('admin_user');
  const userInfo = adminUser ? JSON.parse(adminUser) : null;
  const roleName = userInfo?.role_name || null;
  
  // 根据角色跳转到不同页面
  if (roleName === '项目经理') {
    return <Navigate to="/admin/today-open-bid" replace />;
  } else if (roleName === '财务人员') {
    return <Navigate to="/admin/order-management" replace />;
  }
  return <Navigate to="/admin/dashboard" replace />;
}

// 权限编号映射
// 1: 仪表盘, 2: 招标信息管理, 3: 订单中心, 4: 信息发布, 5: 账号管理, 6: 后台管理, 7: 下载中心, 8: 开标大厅
const routePermissionMap: Record<string, number> = {
  'dashboard': 1,
  'bid-tender': 2,
  'bid-change': 2,
  'bid-result': 2,
  'bid-other': 2,
  'order-management': 3,
  'supplier-registration': 3,
  'other-announcement-registration': 3,
  'info-company': 4,
  'info-industry': 4,
  'info-policy': 4,
  'account-supplier-audit': 5,
  'account-supplier': 5,
  'account-expert-audit': 5,
  'account-expert': 5,
  'account-purchaser': 5,
  'system-members': 6,
  'system-roles': 6,
  'system-feedback': 6,
  'system-download-records': 6,
  'download-center': 7,
  'today-open-bid': 8,
};

// 无权限提示组件
function NoPermission() {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '60vh',
      color: '#6b7280'
    }}>
      <div style={{ fontSize: 64, marginBottom: 16 }}>🚫</div>
      <h2 style={{ color: '#1f2937', marginBottom: 8 }}>无访问权限</h2>
      <p>您没有权限访问此页面，请联系管理员</p>
    </div>
  );
}

// 管理后台页面内容
function AdminContent() {
  const location = useLocation();
  const adminRoute = location.pathname.replace(/^\/admin\/?/, '') || 'dashboard';
  
  // 获取用户权限
  const adminUser = localStorage.getItem('admin_user');
  const userInfo = adminUser ? JSON.parse(adminUser) : null;
  const userPermissions: number[] = userInfo?.permission || [];
  const roleName = userInfo?.role_name || null;
  
  // 检查是否有权限
  const hasPermission = (route: string) => {
    const requiredPermission = routePermissionMap[route];
    if (!requiredPermission) return true; // 未定义权限的路由默认允许
    return userPermissions.includes(requiredPermission);
  };
  
  // 检查角色对订单中心子菜单的访问权限
  const checkOrderCenterRouteAccess = (route: string) => {
    // 只对订单中心的子菜单进行角色检查
    if (route !== 'order-management' && route !== 'supplier-registration' && route !== 'other-announcement-registration') {
      return true;
    }
    
    if (roleName === '财务人员') {
      // 财务人员：只能访问订单管理
      return route === 'order-management';
    } else if (roleName === '项目经理') {
      // 项目经理：只能访问供应商报名清单和其他公告报名清单
      return route === 'supplier-registration' || route === 'other-announcement-registration';
    }
    
    // 其他角色：允许访问所有订单中心子菜单
    return true;
  };
  
  // 根据角色设置默认页面重定向
  if (adminRoute === 'dashboard' || adminRoute === '') {
    if (roleName === '项目经理') {
      return <Navigate to="/admin/today-open-bid" replace />;
    } else if (roleName === '财务人员') {
      return <Navigate to="/admin/order-management" replace />;
    }
  }
  
  // 如果没有权限，显示无权限页面
  if (!hasPermission(adminRoute)) {
    return (
      <AdminLayout>
        <NoPermission />
      </AdminLayout>
    );
  }
  
  // 检查角色对订单中心子菜单的访问权限
  if (!checkOrderCenterRouteAccess(adminRoute)) {
    return (
      <AdminLayout>
        <NoPermission />
      </AdminLayout>
    );
  }
  
  // 页面路由映射
  const renderPage = () => {
    switch (adminRoute) {
      case 'dashboard':
        return <Dashboard />;
      // 招标信息管理
      case 'bid-tender':
        return <BidTender />;
      // case 'bid-change':
      //   return <BidChange />; // 已整合到 bid-tender
      case 'bid-result':
        return <BidResult />;
      case 'bid-other':
        return <BidOther />;
      // 订单中心
      case 'order-management':
        return <OrderCenter />;
      case 'supplier-registration':
        return <SupplierRegistrationList />;
      case 'other-announcement-registration':
        return <OtherAnnouncementRegistrationList />;
      // 信息发布
      case 'info-company':
        return <InfoCompany />;
      case 'info-industry':
        return <InfoIndustry />;
      case 'info-policy':
        return <InfoPolicy />;
      // 账号管理
      case 'account-supplier-audit':
        return <AccountSupplierAudit />;
      case 'account-supplier':
        return <AccountSupplier />;
      case 'account-expert-audit':
        return <AccountExpertAudit />;
      case 'account-expert':
        return <AccountExpert />;
      case 'account-purchaser':
        return <AccountPurchaser />;
      // 后台管理
      case 'system-members':
        return <SystemMembers />;
      case 'system-roles':
        return <SystemRoles />;
      case 'system-feedback':
        return <UserFeedback />;
      case 'system-download-records':
        return <DownloadRecord />;
      // 下载中心
      case 'download-center':
        return <DownloadCenter />;
      // 开标大厅
      case 'today-open-bid':
        return <TodayOpenBid />;
      // 旧页面保留兼容
      case 'users':
        return <Users />;
      case 'members':
        return <Members />;
      case 'bids':
        return <Bids />;
      case 'announcements':
        return <Announcements />;
      case 'invoices':
        return <Invoices />;
      case 'annex':
        return <Annex />;
      default:
        return <Dashboard />;
    }
  };
  
  return (
    <AdminLayout>
      {renderPage()}
    </AdminLayout>
  );
}

// 页面标题管理组件
// 路由变化时滚动到顶部
function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return null;
}

function TitleManager() {
  const location = useLocation();
  
  useEffect(() => {
    if (location.pathname.startsWith('/admin')) {
      document.title = '德润慧通管理后台';
    } else {
      document.title = '德润慧通工程项目管理(四川)有限公司';
    }
  }, [location.pathname]);
  
  return null;
}

// 前台与管理后台：5分钟无操作自动退出
function UserIdleLogout() {
  const location = useLocation();
  const navigate = useNavigate();
  const triggeredRef = useRef(false);

  useEffect(() => {
    const isAdmin = location.pathname.startsWith('/admin');
    const token = localStorage.getItem(isAdmin ? 'admin_token' : 'token');
    if (!token) return;

    const IDLE_TIMEOUT_MS = 5 * 60 * 1000; // 5分钟
    const LAST_ACTIVE_KEY = isAdmin ? 'admin_last_active' : 'web_last_active';

    const doLogout = () => {
      if (triggeredRef.current) return;
      triggeredRef.current = true;
      if (isAdmin) {
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_user');
        localStorage.removeItem(LAST_ACTIVE_KEY);
        message.warning('超过5分钟未操作，已退出登录');
        navigate('/admin/login');
      } else {
        removeToken();
        removeUser();
        localStorage.removeItem(LAST_ACTIVE_KEY);
        message.warning('超过5分钟未操作，已退出登录');
        navigate('/login');
      }
    };

    const markActive = () => {
      if (triggeredRef.current) return;
      localStorage.setItem(LAST_ACTIVE_KEY, String(Date.now()));
    };

    const checkIdle = () => {
      const lastActive = Number(localStorage.getItem(LAST_ACTIVE_KEY) || 0);
      if (!lastActive) return;
      if (Date.now() - lastActive >= IDLE_TIMEOUT_MS) {
        doLogout();
      }
    };

    // 初始化：进入页面视为一次操作
    markActive();

    const onActivity = () => {
      markActive();
    };

    const events: Array<keyof WindowEventMap> = [
      'mousemove',
      'mousedown',
      'keydown',
      'scroll',
      'touchstart',
      'wheel',
      'click',
    ];
    events.forEach((evt) => window.addEventListener(evt, onActivity, { passive: true, capture: true }));

    const interval = window.setInterval(checkIdle, 10 * 1000);

    // 多标签页同步：任意标签页活跃都刷新；任意标签页登出则同步跳转
    const onStorage = (e: StorageEvent) => {
      if (e.key === LAST_ACTIVE_KEY) {
        checkIdle();
      }
      if (e.key === (isAdmin ? 'admin_token' : 'token') && e.newValue === null) {
        const loginPath = isAdmin ? '/admin/login' : '/login';
        if (window.location.pathname !== loginPath) {
          navigate(loginPath);
        }
      }
    };
    window.addEventListener('storage', onStorage);

    return () => {
      events.forEach((evt) => window.removeEventListener(evt, onActivity as any, true));
      window.removeEventListener('storage', onStorage);
      window.clearInterval(interval);
      triggeredRef.current = false;
    };
  }, [location.pathname, navigate]);

  return null;
}

export default function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <BrowserRouter>
        <ScrollToTop />
        <TitleManager />
        <UserIdleLogout />
        <Routes>
          {/* 前端页面 */}
          <Route path="/" element={<HomePage />} />
          <Route path="/register" element={
            <div className="min-h-screen bg-gray-50">
              <Header simple />
              <RegisterPage />
            </div>
          } />
          <Route path="/expert-register" element={
            <div className="min-h-screen bg-gray-50">
              <Header simple />
              <ExpertRegisterPage />
            </div>
          } />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/complete-info" element={
            <div className="min-h-screen bg-gray-50">
              <CompleteInfoPage />
            </div>
          } />
          
          {/* 供应商功能页面 */}
          <Route path="//my-bids" element={<MyBidsPage />} />
          
          {/* 采购人功能页面 */}
          <Route path="/purchaser-bids" element={<PurchaserBidsPage />} />
          <Route path="/trade-announcements" element={<TradeAnnouncementsPage />} />
          <Route path="/announcement-detail/:id" element={<AnnouncementDetailPage />} />
          <Route path="/announcement-detail/:type/:id" element={<AnnouncementDetailPage />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/payment-result" element={<PaymentResultPage />} />
          
          {/* 政策法规 */}
          <Route path="/policies" element={<PolicyListPage />} />
          <Route path="/policy/:id" element={<PolicyDetailPage />} />
          
          {/* 行业动态 */}
          <Route path="/industry-news" element={<IndustryNewsListPage />} />
          <Route path="/industry-news/:id" element={<IndustryNewsDetailPage />} />
          
          {/* 企业文化 */}
          <Route path="/company-culture" element={<CompanyCultureListPage />} />
          <Route path="/company-culture/:id" element={<CompanyCultureDetailPage />} />
          
          {/* 关于我们 */}
          <Route path="/about" element={<AboutPage />} />
          
          {/* 走进德润慧通 */}
          <Route path="/about-xinyuan" element={<AboutXinyuanPage />} />
          
          {/* 资料下载 */}
          <Route path="/downloads" element={<DownloadCenterPage />} />
          
          {/* 合作单位 */}
          <Route path="/partners" element={<PartnersPage />} />
          
          {/* 评审专家功能页面 */}
          <Route path="/expert-evaluation" element={<ExpertEvaluationPage />} />
          
          {/* 管理后台 */}
          <Route path="/admin/login" element={<AdminLoginRoute />} />
          <Route path="/admin" element={<AdminDefaultRoute />} />
          <Route path="/admin/:page" element={
            <AdminRoute>
              <AdminContent />
            </AdminRoute>
          } />
          
          {/* 404 跳转到首页 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}
